import Str from './Str.vue';
import Language from './Language.vue';

export default [
    Str,
    Language
];